// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CheckShield20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckShield20CircleFilled: FC<CheckShield20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m15.708 10.333-4.583 4.604-2.833-2.833 1.062-1.062 1.771 1.77 3.52-3.541 1.063 1.062Z" />
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-4.656-7.188C8.573 18.48 10.125 19.543 12 20c1.875-.458 3.427-1.52 4.656-3.188 1.23-1.666 1.844-3.513 1.844-5.541V6.5L12 4 5.5 6.5v4.77c0 2.029.615 3.876 1.844 5.543Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default CheckShield20CircleFilled;
